// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainContainer__XpAZP {
  display: flex;
  flex-direction: column;
  gap: 30px;
  width: 750px;
  margin-top: 10px;
}

.additionalItemsContainer__dvw9k {
  display: flex;
  flex-direction: column;
}

.additionalItemsHeaders__cGysV {
  display: grid;
  grid-template-columns: 1fr 228px;
  border-bottom: 0.5px solid #d7e5ea;
  justify-items: start;
  padding: 0 0 5px 15px;
}

.divider__c7mjq {
  background-color: #474747;
  width: 100%;
  height: 2px;
}

.additionalItemsHeaders__cGysV > ::-webkit-scrollbar {
  display: none !important;
}

.additionalItemsTable__K70qA {
  display: flex;
  flex-direction: column;
  max-height: 40dvh;
  overflow-y: auto;
}

@media (max-height: 900px) {
  .additionalItemsTable__K70qA {
    max-height: 30dvh;
  }
}

.addItemRowContainer__Ms8or {
  display: grid;
  grid-template-columns: 4fr 1fr 45px;
  grid-template-rows: 45px;
  padding: 0 15px 0 15px;
  justify-items: start;
  box-sizing: border-box;
  border-bottom: 0.5px solid #d7e5ea;
  cursor: pointer;
}

.addItemButton__cVfeT {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.row__Cr3nC {
  display: grid;
  grid-template-columns: 70% 20% 10%;
  justify-items: start;
  grid-template-rows: 40px;
  align-items: center;
  box-sizing: border-box;
}

.rowHeader__ycY8U {
  background-color: white !important;
}

.row__Cr3nC:nth-child(odd) {
  background-color: var(--light-background-grey);
}

.headerCellLeft___IRfo {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 20px;
}

.emptyRow__We1B1 {
  grid-template-columns: 100%;
}

.cell__LYrtq {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 15px;
  box-sizing: border-box;
}

.deleteCell__TZlEP,
.quantityCell__FIg9h {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  gap: 6px;
  align-items: center;
  box-sizing: border-box;
}

.deleteIconContainer__a0oBV {
  width: 40px;
  display: flex;
  justify-content: center;
  cursor: pointer;
}

.table__CGxe_ {
  border-collapse: collapse;
}

td {
  border-bottom: 0;
  border-right: 0;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/components/additional-items-form/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,kCAAkC;EAClC,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB","sourcesContent":[".mainContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  width: 750px;\n  margin-top: 10px;\n}\n\n.additionalItemsContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.additionalItemsHeaders {\n  display: grid;\n  grid-template-columns: 1fr 228px;\n  border-bottom: 0.5px solid #d7e5ea;\n  justify-items: start;\n  padding: 0 0 5px 15px;\n}\n\n.divider {\n  background-color: #474747;\n  width: 100%;\n  height: 2px;\n}\n\n.additionalItemsHeaders > ::-webkit-scrollbar {\n  display: none !important;\n}\n\n.additionalItemsTable {\n  display: flex;\n  flex-direction: column;\n  max-height: 40dvh;\n  overflow-y: auto;\n}\n\n@media (max-height: 900px) {\n  .additionalItemsTable {\n    max-height: 30dvh;\n  }\n}\n\n.addItemRowContainer {\n  display: grid;\n  grid-template-columns: 4fr 1fr 45px;\n  grid-template-rows: 45px;\n  padding: 0 15px 0 15px;\n  justify-items: start;\n  box-sizing: border-box;\n  border-bottom: 0.5px solid #d7e5ea;\n  cursor: pointer;\n}\n\n.addItemButton {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.row {\n  display: grid;\n  grid-template-columns: 70% 20% 10%;\n  justify-items: start;\n  grid-template-rows: 40px;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.rowHeader {\n  background-color: white !important;\n}\n\n.row:nth-child(odd) {\n  background-color: var(--light-background-grey);\n}\n\n.headerCellLeft {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding-left: 20px;\n}\n\n.emptyRow {\n  grid-template-columns: 100%;\n}\n\n.cell {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding-left: 15px;\n  box-sizing: border-box;\n}\n\n.deleteCell,\n.quantityCell {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  gap: 6px;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.deleteIconContainer {\n  width: 40px;\n  display: flex;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.table {\n  border-collapse: collapse;\n}\n\ntd {\n  border-bottom: 0;\n  border-right: 0;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `mainContainer__XpAZP`,
	"additionalItemsContainer": `additionalItemsContainer__dvw9k`,
	"additionalItemsHeaders": `additionalItemsHeaders__cGysV`,
	"divider": `divider__c7mjq`,
	"additionalItemsTable": `additionalItemsTable__K70qA`,
	"addItemRowContainer": `addItemRowContainer__Ms8or`,
	"addItemButton": `addItemButton__cVfeT`,
	"row": `row__Cr3nC`,
	"rowHeader": `rowHeader__ycY8U`,
	"headerCellLeft": `headerCellLeft___IRfo`,
	"emptyRow": `emptyRow__We1B1`,
	"cell": `cell__LYrtq`,
	"deleteCell": `deleteCell__TZlEP`,
	"quantityCell": `quantityCell__FIg9h`,
	"deleteIconContainer": `deleteIconContainer__a0oBV`,
	"table": `table__CGxe_`
};
export default ___CSS_LOADER_EXPORT___;
